export enum MediaDescriptionProperties {
  Name = 'name',
  Description = 'description',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  NameDefault = 'nameDefault',
  DescriptionDefault = 'descriptionDefault',
}
export enum MediaDescriptionMetaProperties {
  NameId = 'Name-id',
  NameVersion = 'Name-version',
  DescriptionId = 'Description-id',
  DescriptionVersion = 'Description-version',
}
